import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  mapPlaylistCardToContentCardAction,
  mapPlaylistCardToContentCardItem,
  openPlaylistCard,
} from '@app/app/shared/collections/card-item/card-item-content-card.mapper';
import { V3ContentCardComponent } from '@app/app/shared/components-v3/content-card/v3-content-card.component';
import { PlaylistCardShort } from '@app/app/shared/models';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'ptl-card-item-main-view',
  standalone: true,
  imports: [V3ContentCardComponent],
  templateUrl: './card-item-main-view.component.html',
  styleUrls: ['./card-item-main-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardItemMainViewComponent {
  private readonly transloco = inject(TranslocoService);
  private readonly activeLang = toSignal(this.transloco.langChanges$, {
    initialValue: this.transloco.getActiveLang(),
  });

  card = input.required<PlaylistCardShort>();
  cardIndex = input(0);

  cardClick = output<PlaylistCardShort>();

  protected readonly cardItem = computed(() => {
    this.activeLang();
    return mapPlaylistCardToContentCardItem(this.card(), this.cardIndex(), this.transloco);
  });

  protected readonly action = computed(() => {
    this.activeLang();
    return mapPlaylistCardToContentCardAction(this.card(), this.transloco);
  });

  onCardOpen(): void {
    openPlaylistCard(this.card(), (card) => this.cardClick.emit(card));
  }
}
